import React from "react";
import { DataProtectionSection } from "@/.storyblok/types/319751/storyblok-components";
import { renderRichText } from "@/lib/richText";
import {SbBlokData, storyblokEditable} from "@storyblok/react";
import Link from "next/link";
import bgDots from '@/assets/images/shared/bg-dots.svg';
import bgDotsCircle from '@/assets/images/shared/bg-dots-circle.svg';
import Image from "next/image";

interface DataProtectionSectionProps {
  blok?: DataProtectionSection & SbBlokData;
}

const DataProtectionSectionComponent: React.FC<DataProtectionSectionProps> = ({ blok }) => {
  if (!blok) return null;

  const { title, subtitle, items } = blok;

  return (
    <div {...storyblokEditable(blok)} className="bg-white text-center overflow-hidden position-relative component-simple-content py-4 py-md-5">
      <div className="container container lead">
        {title && <h2 className="col-24 mb-4">{title}</h2>}

        {subtitle && (
            <div
              className="lead max-two-thirds mb-5"
              dangerouslySetInnerHTML={{ __html: renderRichText(subtitle) }}
            />
        )}

        {items?.map((item, index) => (
          <React.Fragment key={item._uid}>
            <div className="bg-light rounded-4 mx-xl-5 mb-4 mb-xl-5 overflow-hidden p-4 p-xl-5 position-relative z-1 scroll-trigger slide-up on">
              <div className="row g-4 g-xl-5 text-start justify-content-center">
                <div className="col col-24 col-lg-10">
                  {item.icon && (
                    <div
                      className="badge-circle text-white mb-4"
                      dangerouslySetInnerHTML={{ __html: item.icon }}
                    />
                  )}
                  {item.left_subtitle && (
                    <p className="pretitle mb-2 text-dark">{item.left_subtitle}</p>
                  )}
                  {item.left_title && (
                    <h3 className="h2 mb-2">{item.left_title}</h3>
                  )}
                </div>
                <div className="col col-24 col-lg-14">
                  {item.right_content && (
                    <div
                    className="content-wrapper"
                    dangerouslySetInnerHTML={{ __html: renderRichText(item.right_content) }}
                />
                  )}
                  {item.right_button_text && item.right_button_link && (
                    <Link
                      href={item.right_button_link.url || '#'}
                      className="btn btn-primary"
                      {...(item.right_button_link.target === '_blank' ? {
                        target: '_blank',
                        rel: 'noopener'
                      } : {})}
                    >
                      {item.right_button_text}
                    </Link>
                  )}
                </div>
              </div>
            </div>


            {index % 2 === 0 ? (
              <Image
                alt=""
                className="bg-dots bg-dots-left"
                src={bgDots}
                width={300}
                height={300}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                loading="lazy"
                quality={75}
              />
            ) : (
              <Image
                alt=""
                className="bg-dots bg-dots-right bg-dots-100"
                src={bgDotsCircle}
                width={300}
                height={300}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                loading="lazy"
                quality={75}
              />
            )}
          </React.Fragment>
        ))}

        <div className="bg-glow bg-glow-dark"></div>
      </div>
    </div>
  );
};

export default DataProtectionSectionComponent;